import { useEffect } from "react";

// Lightweight per-page SEO: updates <title>, meta description and canonical.
export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) return;
      el.setAttribute(attr, value);
    };
    const ensure = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) { el = create(); document.head.appendChild(el); }
      return el;
    };
    if (description) {
      const m = ensure('meta[name="description"]', () => {
        const e = document.createElement("meta"); e.setAttribute("name", "description"); return e;
      });
      m.setAttribute("content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (path) {
      const link = ensure('link[rel="canonical"]', () => {
        const e = document.createElement("link"); e.setAttribute("rel", "canonical"); return e;
      });
      link.setAttribute("href", `https://axioform3d.com${path}`);
      setMeta('meta[property="og:url"]', "content", `https://axioform3d.com${path}`);
    }
  }, [title, description, path]);
}
